<template>
  <div v-if="stock_out && stock_out.actions">
    <v-sheet class="pt-1 transparent-background-color d-inline-block">
      <v-tooltip
        top
        v-if="showView && $permission.permissionAllow('StockOuts', 'view')"
      >
        <template v-slot:activator="{ on, attrs }">
          <!-- 明细跳转 -->
          <v-btn
            v-bind="attrs"
            v-on="on"
            small
            dark
            color="info"
            class="px-2 me-2 mb-1"
            :href="
              productionFlg
                ? '/#/production-stock-out/' + stock_out.id
                : orderFlg
                ? '/#/order-stock-out/' + stock_out.id
                : (('/#/stock-orders-out/' + stock_out.id) + ((stock_out.type == 11) ? '?broken_type=' + stock_out.broken_type : ''))
            "
          >
            <v-icon x-small class="pe-1">fa-align-left</v-icon>
            {{ $t("Opt.details") }}
          </v-btn>
        </template>
        <span>{{ $t("CRUD.viewInfo", [$t("StockOrderOUT.ObjectName")]) }}</span>
      </v-tooltip>
      <v-tooltip
        top
        v-if="
          showComplete &&
          stock_out.stock &&
          !stock_out.stock.pack_setting &&
          !stock_out.stock.container_setting &&
          stock_out.stock.wms_setting &&
          stock_out.actions &&
          stock_out.actions.out_complete &&
          $permission.permissionAllow('StockOuts', 'packConfirm')
        "
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            v-on="on"
            small
            dark
            color="action"
            class="px-2 me-2 mb-1"
            @click.stop="$emit('packConfirm', stock_out)"
          >
            <v-icon x-small class="pe-1">fa-box</v-icon>
            {{ $t("StockOrderOUT.actions.completePackConfirm") }}
          </v-btn>
        </template>
        <span>{{ $t("StockOrderOUT.actions.outCompletePackConfirm") }}</span>
      </v-tooltip>
      <!-- 出库 -->
      <v-tooltip
        top
        v-if="
          showComplete &&
          stock_out.stock &&
          !stock_out.stock.wms_setting &&
          stock_out.actions &&
          stock_out.actions.out_complete &&
          stock_out.stock.wms_setting == 0 &&
          $permission.permissionAllow('StockOuts', 'out')
        "
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            v-on="on"
            small
            dark
            color="action"
            class="px-2 me-2 mb-1"
            @click.stop="out()"
          >
            {{ $t("StockOrderOUT.actions.stockOut") }}
          </v-btn>
        </template>
        <span>{{ $t("StockOrderOUT.actions.stockOut") }}</span>
      </v-tooltip>
      <v-tooltip
        top
        v-if="
          showEdit &&
          stock_out.actions &&
          stock_out.actions.out_edit &&
          !(
            stock_out.type == 1 &&
            stock_out.order_flg == 1 &&
            settings &&
            settings.sub_account_enable
          ) &&
          $permission.permissionAllow('StockOuts', 'edit')
        "
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            v-on="on"
            small
            dark
            color="primary"
            class="px-2 me-2 mb-1"
            @click.stop="
              $permission.checkAccountExpired().then(() => {
                detailMode
                  ? $emit('edit')
                  : productionFlg
                  ? $router.push(
                      '/production-stock-out/' + stock_out.id + '/edit'
                    )
                  : orderFlg
                  ? $router.push('/order-stock-out/' + stock_out.id + '/edit')
                  : $router.push('/stock-orders-out/' + stock_out.id + '/edit');
              })
            "
          >
            <v-icon x-small class="pe-1">fa-pencil-alt</v-icon>
            {{ $t("StockOrderOUT.actions.edit") }}
          </v-btn>
        </template>
        <span>{{ $t("StockOrderOUT.actions.editStockOUT") }}</span>
      </v-tooltip>
      <v-tooltip
        top
        v-if="
          showApprove &&
          stock_out.actions &&
          stock_out.actions.out_approve &&
          $permission.permissionAllow('StockOuts', 'approve')
        "
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            v-on="on"
            small
            dark
            color="action"
            class="px-2 me-2 mb-1"
            @click.stop="doAction('approve')"
          >
            <v-icon x-small class="pe-1">fa-stamp</v-icon>
            {{ $t("StockOrderOUT.actions.approve") }}
          </v-btn>
        </template>
        <span>{{ $t("StockOrderOUT.actions.approveStockOUT") }}</span>
      </v-tooltip>
      <v-tooltip
        top
        v-if="
          showSheetPrint &&
          !stock_out.cancel_flg &&
          $permission.permissionAllow('StockOuts', 'view')
        "
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            v-on="on"
            small
            dark
            color="action"
            class="px-2 me-2 mb-1"
          >
            <v-icon x-small class="pe-1">fa-receipt</v-icon>
            {{ $t("StockOrderOUT.actions.kdnCallExpress") }}
          </v-btn>
        </template>
        <span>{{ $t("StockOrderOUT.actions.kdnCallExpress") }}</span>
      </v-tooltip>
      <v-tooltip
        top
        v-if="
          showCancel &&
          stock_out.actions &&
          stock_out.actions.out_cancel &&
          $permission.permissionAllow('StockOuts', 'cancel')
        "
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            v-on="on"
            small
            dark
            color="danger"
            class="px-2 me-2 mb-1"
            @click.stop="doAction('cancel')"
          >
            <v-icon x-small class="pe-1">fa-exclamation</v-icon>
            {{ $t("StockOrderOUT.actions.cancel") }}
          </v-btn>
        </template>
        <span>{{ $t("StockOrderOUT.actions.cancelStockOUT") }}</span>
      </v-tooltip>
      <!-- 物流 -->
      <v-tooltip
        top
        v-if="
          showLogistic &&
          $permission.permissionAllow(
            'Requisitions',
            'getRequisitionLogistic'
          ) &&
          requisition &&
          requisition.logistics_json
        "
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            v-on="on"
            small
            dark
            color="orange"
            class="px-2 me-2 mb-1"
            @click.stop="editLogisticAlert = true"
          >
            {{ $t("Distribution.actions.logistic") }}
          </v-btn>
        </template>
        <span>{{ $t("Distribution.actions.logistic") }}</span>
      </v-tooltip>
      <!-- 打印 -->
      <v-menu
        v-if="
          !stock_out.cancel_flg &&
          ((stock_out.type == 1 &&
            $permission.permissionAllow('StockOuts', 'distributionPrint')) ||
            $permission.permissionAllow('StockOuts', 'stockOrderPrint') ||
            (stock_out.type == 1 &&
              $permission.permissionAllow('StockOuts', 'distributionPrint')))
        "
        v-model="printBtnMenu"
        open-on-hover
        close-on-click
        close-on-content-click
        offset-y
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            v-on="on"
            small
            dark
            color="print"
            class="px-2 me-2 mb-1"
          >
            <v-icon x-small class="pe-1">fa-print</v-icon>
            {{ $t("Print.print") }}
            <v-icon x-small class="ps-1">
              {{ printBtnMenu ? "fa-caret-up" : "fa-caret-down" }}
            </v-icon>
          </v-btn>
        </template>
        <v-list dense>
          <!-- 预打印配送单 -->
          <v-list-item
            v-if="
              stock_out.type == 1 &&
              $permission.permissionAllow('StockOuts', 'distributionPrint')
            "
            @click.stop="doPrint('distributionPrint')"
          >
            <v-list-item-title>
              {{ $t("StockOrderOUT.actions.distrubitionPrePrint") }}
              <span v-if="stock_out.distribution_print_count">
                {{
                  $t("Global.brackets", [stock_out.distribution_print_count])
                }}
              </span>
            </v-list-item-title>
          </v-list-item>
          <v-divider v-if="stock_out.type == 1" />
          <!-- 出库单明细打印 -->
          <v-list-item
            v-if="$permission.permissionAllow('StockOuts', 'stockOrderPrint')"
            @click.stop="
              $permission.checkAccountExpired().then(() => {
                // TODO
                doPrint('stockOUTDetailPrint');
              })
            "
          >
            <v-list-item-title>
              {{ $t("StockOrderOUT.actions.stockOUTDetailPrint")
              }}<span v-if="stock_out.print_count">
                {{ $t("Global.brackets", [stock_out.print_count]) }}
              </span>
            </v-list-item-title>
          </v-list-item>
          <!-- 发货明细单打印 -->
          <v-list-item
            v-if="
              stock_out.type == 1 &&
              $permission.permissionAllow('StockOuts', 'distributionPrint')
            "
            @click.stop="
              $permission.checkAccountExpired().then(() => {
                doPrint('deliveryDetailPrint');
              })
            "
          >
            <v-list-item-title>
              {{ $t("StockOrderOUT.actions.deliveryDetailPrint") }}
            </v-list-item-title>
          </v-list-item>
          <!-- 面单打印 -->
          <!-- <v-list-item
            v-if="
              stock_out.type == 1 &&
              $permission.permissionAllow('StockOuts', 'view')
            "
            @click.stop="
              $permission.checkAccountExpired().then(() => {
                // TODO
              })
            "
          >
            <v-list-item-title>
              {{ $t("StockOrderOUT.actions.expressSheetPrint") }}
            </v-list-item-title>
          </v-list-item> -->
        </v-list>
      </v-menu>

      <!-- 云打印 -->
      <v-menu
        v-if="
          !stock_out.cancel_flg &&
          ((stock_out.type == 1 &&
            $permission.permissionAllow('StockOuts', 'distributionPrint')) ||
            $permission.permissionAllow('StockOuts', 'stockOrderPrint') ||
            (stock_out.type == 1 &&
              $permission.permissionAllow('StockOuts', 'distributionPrint'))) &&
          $permission.permissionAllow('CloudPrints', 'index') &&
          settings &&
          settings.cloud_print_enable
        "
        v-model="cloudPrintBtnMenu"
        open-on-hover
        close-on-click
        close-on-content-click
        offset-y
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            v-on="on"
            small
            dark
            color="print"
            class="px-2 me-2 mb-1"
          >
            <v-icon x-small class="pe-1">fa-print</v-icon>
            {{ $t("Print.cloud_print") }}
            <v-icon x-small class="ps-1">
              {{ cloudPrintBtnMenu ? "fa-caret-up" : "fa-caret-down" }}
            </v-icon>
          </v-btn>
        </template>
        <v-list dense>
          <!-- 预打印配送单 -->
          <v-list-item
            v-if="
              stock_out.type == 1 &&
              $permission.permissionAllow('StockOuts', 'distributionPrint')
            "
            @click.stop="doCloudPrint('distribution')"
          >
            <v-list-item-title>
              {{ $t("StockOrderOUT.actions.distrubitionPrePrint") }}
              <span v-if="stock_out.distribution_print_count">
                {{
                  $t("Global.brackets", [stock_out.distribution_print_count])
                }}
              </span>
            </v-list-item-title>
          </v-list-item>
          <v-divider v-if="stock_out.type == 1" />
          <!-- 出库单明细打印 -->
          <v-list-item
            v-if="$permission.permissionAllow('StockOuts', 'stockOrderPrint')"
            @click.stop="
              $permission.checkAccountExpired().then(() => {
                // TODO
                doCloudPrint('stockOrderOut');
              })
            "
          >
            <v-list-item-title>
              {{ $t("StockOrderOUT.actions.stockOUTDetailPrint") }}
            </v-list-item-title>
          </v-list-item>
          <!-- 发货明细单打印 -->
          <v-list-item
            v-if="
              stock_out.type == 1 &&
              $permission.permissionAllow('StockOuts', 'distributionPrint')
            "
            @click.stop="
              $permission.checkAccountExpired().then(() => {
                doCloudPrint('shipStockOrderOut');
              })
            "
          >
            <v-list-item-title>
              {{ $t("StockOrderOUT.actions.deliveryDetailPrint") }}
            </v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>

      <!-- 导出 -->
      <v-menu
        v-if="
          (!stock_out.cancel_flg &&
            $permission.permissionAllow('StockOuts', 'detailExport')) ||
          ($permission.permissionAllow('StockOuts', 'outSortingExport') &&
            stock_out.type != 4)
        "
        v-model="exportBtnMenu"
        open-on-hover
        close-on-click
        close-on-content-click
        offset-y
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            v-on="on"
            small
            dark
            color="print"
            class="px-2 me-2 mb-1"
          >
            <v-icon x-small class="pe-1">fa-file-export</v-icon>
            {{ $t("Export.export", [""]) }}
            <v-icon x-small class="ps-1">
              {{ exportBtnMenu ? "fa-caret-up" : "fa-caret-down" }}
            </v-icon>
          </v-btn>
        </template>
        <v-list dense>
          <v-list-item
            v-if="$permission.permissionAllow('StockOuts', 'detailExport')"
            @click.stop="
              $permission.checkAccountExpired().then(() => {
                exportDetail();
              })
            "
          >
            <v-list-item-title>
              {{ $t("StockOrderOUT.actions.stockOUTDetailExport") }}
            </v-list-item-title>
          </v-list-item>
          <!-- 发货明细单导出 -->
          <v-list-item
            v-if="
              $permission.permissionAllow('StockOuts', 'outSortingExport') &&
              stock_out.type != 4
            "
            @click.stop="
              $permission.checkAccountExpired().then(() => {
                exportOutSortingDetail();
              })
            "
          >
            <v-list-item-title>
              {{ $t("StockOrderOUT.actions.deliveryDetailExport") }}
            </v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
      <!-- 分拣出库 -->
      <v-tooltip
        top
        v-if="
          showSortingOut &&
          stock_out.actions &&
          stock_out.actions.common_sorting_out &&
          $permission.permissionAllow('StockOuts', 'sortingOutView')
        "
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            v-on="on"
            small
            dark
            color="action"
            class="px-2 me-2 mb-1"
            @click.stop="
              $route.path.startsWith('/order-stock-out')
                ? $router.push(
                    '/order-stock-out/detail/common-sorting-out/' + stock_out.id
                  )
                : $router.push(
                    '/stock-orders-out/detail/common-sorting-out/' +
                      stock_out.id
                  )
            "
          >
            {{ $t("StockOrderOUT.actions.sortingOut") }}
          </v-btn>
        </template>
        <span>{{ $t("StockOrderOUT.actions.stockOut") }}</span>
      </v-tooltip>
    </v-sheet>

    <v-dialog v-model="stockOutDialog" max-width="480px">
      <v-card>
        <v-card-title class="mx-3">
          {{ $t("$vuetify.alert") }}
          <v-spacer></v-spacer>
          <v-tooltip left>
            <template v-slot:activator="{ on, attrs }">
              <v-icon v-bind="attrs" v-on="on" @click="stockOutDialog = false">
                fa-times
              </v-icon>
            </template>
            {{ $t("$vuetify.close") }}
          </v-tooltip>
        </v-card-title>
        <v-divider />
        <v-card-text class="px-4 py-8 text-center subtitle-1">
          <v-row>
            <v-col class="pa-2 d-flex">
              <span class="secondary--text">
                {{ $t("StockOrderOUT.Fields.executer_name")
                }}{{ $t("Global.colon") }}
              </span>
              <SearcherAccountUser
                v-model="executeUserSelected"
                :type="[1, 2]"
                noLabel
                single-line
                dense
                hide-details
                class="d-inline mt-0 mb-n1"
                unclearable
              />
            </v-col>
          </v-row>
          <v-row class="my-2">
            <v-col class="pa-2">
              <span class="danger--text">{{
                $t("StockOrderOUT.Messages.stock_order_out_confirm_out")
              }}</span>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn color="secondary" outlined @click="stockOutDialog = false">
            {{ $t("$vuetify.close") }}
          </v-btn>
          <v-btn
            color="accent"
            depressed
            @click="
              confirmOut();
              stockOutDialog = false;
            "
          >
            {{ $t("$vuetify.confirm") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog persistent v-model="dialog" max-width="480px">
      <v-card>
        <v-card-title class="mx-3">
          {{ $t("$vuetify.alert") }}
          <v-spacer></v-spacer>
          <v-tooltip left>
            <template v-slot:activator="{ on, attrs }">
              <v-icon v-bind="attrs" v-on="on" @click="dialog = false">
                fa-times
              </v-icon>
            </template>
            {{ $t("$vuetify.close") }}
          </v-tooltip>
        </v-card-title>
        <v-divider />
        <v-card-text class="px-4 py-8 text-center subtitle-1">
          {{ stock_out.third_return ? stock_out.third_return.msg : "" }}
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            v-if="stock_out.third_return && stock_out.third_return.status == 3"
            color="accent"
            outlined
            @click="
              pushAgain();
              dialog = false;
            "
          >
            {{ $t("StockOrderOUT.actions.pushAgain") }}
          </v-btn>
          <v-btn color="secondary" outlined depressed @click="dialog = false">
            {{ $t("$vuetify.close") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <ShowRequisitionLogisticAlert
      v-model="editLogisticAlert"
      :requisitionId="requisition.id"
      @editLogistic="$emit('editLogistic')"
    />
  </div>
</template>

<script>
import { mapState } from "vuex";
import StockOuts from "@/api/stock_outs";
import Requisitions from "@/api/requisitions";
import SearcherAccountUser from "@/components/plugins/SearcherAccountUser";
import ShowRequisitionLogisticAlert from "@/components/plugins/ShowRequisitionLogisticAlert";
import makeData from "../../distributions/makeData";
import CloudPrintTemplates from "@/api/cloud_print_templates";
import DeliverDetail from "@/api/stock_outs";

export default {
  name: "StockOrderOUTActions",

  props: {
    productionFlg: Boolean,
    orderFlg: Boolean,
    stock_out: Object,
    detailMode: Boolean,
    showView: Boolean,
    showEdit: Boolean,
    showApprove: Boolean,
    showCancel: Boolean,
    showComplete: Boolean,
    showSheetPrint: Boolean,
    showCloudPrint: Boolean,
    showSortingOut: Boolean,
    showLogistic: Boolean,
  },

  components: {
    SearcherAccountUser,
    ShowRequisitionLogisticAlert,
  },

  computed: {
    // 使用对象展开运算符将此对象混入到外部对象中
    ...mapState(["settings", "accountUser"]),
  },

  data: () => ({
    printBtnMenu: false,
    cloudPrintBtnMenu: false,
    exportBtnMenu: false,
    stockOutDialog: false,
    executeUserSelected: null,
    dialog: false,
    requisition: {},
    editLogisticAlert: false,
  }),

  methods: {
    actionMethod(mode) {
      if (mode == "approve") return StockOuts.approve(this.stock_out.id);
      else if (mode == "cancel") return StockOuts.cancel(this.stock_out.id);
    },
    doAction(mode) {
      this.$permission.checkAccountExpired().then(
        function () {
          this.actionMethod(mode).then(
            function (response) {
              if (response.data.status.isOK()) {
                this.$emit("done");
              }
            }.bind(this)
          );
        }.bind(this)
      );
    },
    doPrint(mode) {
      this.$permission.checkAccountExpired().then(
        function () {
          switch (mode) {
            case "distributionPrint":
              this.$router.push(
                "/print/stock-order-out-distribution-print/" + this.stock_out.id
              );
              break;
            case "stockOUTDetailPrint":
              this.$router.push(
                "/print/stock-out-detail-print/" + this.stock_out.id
              );
              break;
            case "deliveryDetailPrint":
              this.$router.push(
                "/print/deliver-detail-print/" + this.stock_out.id
              );
              break;
          }
        }.bind(this)
      );
    },
    doCloudPrint(mode) {
      this.$permission.checkAccountExpired().then(
        function () {
          if (mode == "distribution") {
            StockOuts.distributionPrint(this.stock_out.id).then(
              function (response) {
                if (response.data.status.isOK()) {
                  let stock_out = response.data.stock_out;
                  let order_address = response.data.order_address;
                  let distribution = makeData.processDetails(
                    stock_out.distribution
                  );
                  stock_out.order.shop = this.$printUtils.addCitiesName(
                    stock_out.order.shop
                  );
                  CloudPrintTemplates.print({
                    print_template_code: mode,
                    object: {
                      order: stock_out.order,
                      distribution: Object.assign({}, stock_out, distribution),
                      order_address: order_address,
                    },
                  });
                }
              }.bind(this)
            );
          } else if (mode == "shipStockOrderOut") {
            //获取单据详情
            StockOuts.orderOutPrint(this.stock_out.id).then(
              function (response) {
                if (response.data.status.isOK()) {
                  let stockOrderOut = response.data.stock_out;
                  if (stockOrderOut.order_address) {
                    stockOrderOut.order_address = response.data.order_address;
                  }
                  stockOrderOut = makeData.processDetails(stockOrderOut);
                  CloudPrintTemplates.print({
                    print_template_code: mode,
                    object: stockOrderOut,
                  });
                }
              }.bind(this)
            );
          } else if (mode == "stockOrderOut") {
            //获取单据详情
            DeliverDetail.deliverDetailPrint(this.stock_out.id).then(
              function (response) {
                if (response.data.status.isOK()) {
                  let stock_out = response.data.stock_out;
                  CloudPrintTemplates.print({
                    print_template_code: mode,
                    object: stock_out,
                  });
                }
              }.bind(this)
            );
          }
        }.bind(this)
      );
    },
    out() {
      if (
        this.stock_out.third_return &&
        this.stock_out.third_return.push_platform == 1010
      ) {
        this.dialog = true;
      } else if (
        this.stock_out.type == 1 ||
        this.stock_out.type == 2 ||
        this.stock_out.type == 4 ||
        this.stock_out.type == 13 ||
        this.stock_out.type == 17
      ) {
        if (this.orderFlg) {
          this.$router.push("/order-stock-out/" + this.stock_out.id + "/out");
        } else if (this.productionFlg) {
          this.$router.push(
            "/production-stock-out/" + this.stock_out.id + "/out"
          );
        } else {
          this.$router.push("/stock-orders-out/" + this.stock_out.id + "/out");
        }
      } else {
        this.stockOutDialog = true;
      }
    },
    pushAgain() {
      StockOuts.pushAgain(this.stock_out.id).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.$emit("done");
          }
        }.bind(this)
      );
    },
    confirmOut() {
      StockOuts.fetchOne(this.stock_out.id).then(
        function (response) {
          if (response.data.status.isOK()) {
            StockOuts.out(response.data.stock_out).then(
              function (response) {
                if (response.data.status.isOK()) {
                  this.$emit("done");
                }
              }.bind(this)
            );
          }
        }.bind(this)
      );
    },
    exportDetail() {
      StockOuts.exportDetail(this.stock_out.id);
    },
    exportOutSortingDetail() {
      StockOuts.exportOutSortingDetail(this.stock_out.id);
    },
  },

  watch: {
    accountUser: {
      immediate: true,
      handler() {
        this.executeUserSelected = this.accountUser ? this.accountUser : null;
      },
    },
    stock_out: {
      handler() {
        if (this.stock_out) {
          if (
            this.detailMode &&
            this.stock_out.type == 2 &&
            this.showLogistic
          ) {
            Requisitions.getRequisitionLogistic({
              stock_order_code: this.stock_out.stock_order_code,
            }).then(
              function (response) {
                if (response.data.status.isOK()) {
                  this.requisition = response.data.requisition;
                }
              }.bind(this)
            );
          }
        }
      },
    },
  },
};
</script>